import { render, staticRenderFns } from "./TopDappsCard.vue?vue&type=template&id=7f9df0d3&scoped=true"
import script from "./TopDappsCard.vue?vue&type=script&lang=ts"
export * from "./TopDappsCard.vue?vue&type=script&lang=ts"
import style0 from "./TopDappsCard.vue?vue&type=style&index=0&id=7f9df0d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9df0d3",
  null
  
)

export default component.exports